import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Button from 'react-bootstrap/Button';
import withStyles from 'isomorphic-style-loader/withStyles';
import CurrencyConverter from '../../../CurrencyConverter/CurrencyConverter';
import { openDescriptionModal } from '../../../../actions/siteadmin/modalActions';
import cx from 'classnames';
import { api, subCategoryUploadDir } from '../../../../config';
import messages from '../../../../locale/messages';

import Increment from '/public/Icons/increment.svg';
import Decrement from '/public/Icons/decrement.svg';
import bt from '../../../../components/commonStyle.css';

class SubCategoryItem extends React.Component {

    render() {
        const { id, image, name, description, openDescriptionModal, handleRemoveOrder, removeOrderQuantity } = this.props;
        const { pricingType, pricingDetails, categoryId, handleAddOrder, existsItems, addOrderQuantity, quantity } = this.props;
        const { categoryData } = this.props;
        const { formatMessage } = this.props.intl;
        let isDisabled = pricingDetails?.multiplierValue <= quantity, isAdd = quantity <= 0, isRemove = quantity == 1

        return (
            <>
                <div className='subCategoryImgBox'>
                    <div className='subCategoryImgContainer'>
                        <img src={api.apiEndpoint + subCategoryUploadDir + 'medium_' + image} alt={name || ''} />
                    </div>
                </div>
                <div className='subCategoryInfoContainer'>
                    <div>
                        <p className='subCategoryInfoHeading commonHeading16'>{name}</p>
                        <p className='subCategoryInfoSubHeading commonHeading14'>
                            <span> {formatMessage(messages[pricingType == 'hourly' ? 'minHr' : 'maxQty'])} {pricingDetails?.multiplierValue}</span>
                            <span>{pricingType == 'hourly' ? (pricingDetails?.multiplierValue > 1 ? 'hr(s)' : 'hr') : ''}</span>
                        </p>
                        <div className='subCategoryInfoAmount commonHeading16'><CurrencyConverter amount={pricingDetails.convertBasePrice} />{pricingType == 'hourly' ? '/hr' : '/Qty'}</div>
                    </div>
                    <div style={{ textAlign: "start" }}><div onClick={() => openDescriptionModal({ name, description })} className='subCategoryInfoModalLink'>{formatMessage(messages.jobDescription)}</div></div>
                    {
                        pricingType == 'hourly' ? <div>
                            <Button onClick={() => existsItems ? handleRemoveOrder(id) : handleAddOrder({ subCategoryId: id, categoryId, name, categoryData, pricingDetails })} className={cx((existsItems ? [bt.btnSecondary, bt.fullWidth] : [bt.btnPrimary, bt.fullWidth]))}>
                                {formatMessage(messages[existsItems ? 'remove' : 'add'])}
                            </Button></div>
                            : <div>
                                {(!existsItems || isAdd) && <Button onClick={() => handleAddOrder({ subCategoryId: id, categoryId, quantity: 1, name, categoryData, pricingDetails })} className={cx(bt.btnPrimary, bt.fullWidth)}>{formatMessage(messages.add)}</Button>}
                                {existsItems && !isAdd &&
                                    <div className='subCategoryImgBtnContainer'>
                                        <span className='subCategoryImgBtn'>
                                            <img src={Decrement} alt={formatMessage(messages.remove)} role="button" onClick={() => isRemove ? handleRemoveOrder(id) : removeOrderQuantity({ id, categoryId })} /></span>
                                        {quantity}
                                        <span className={cx(isDisabled && 'subCategoryImgBtnDisabled', 'subCategoryImgBtn')}>
                                            <img src={Increment} alt={formatMessage(messages.add)} role="button" onClick={() => !isDisabled && addOrderQuantity({ id, categoryId })} />
                                        </span>
                                    </div>}
                            </div>
                    }
                </div>
            </>
        )
    }
}

const mapState = (state) => ({});
const mapDispatch = {
    openDescriptionModal
};
export default injectIntl(withStyles(bt)(connect(mapState, mapDispatch)(SubCategoryItem)));